import _ from 'lodash';
export class VersionedAnswers {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/naming-convention
    __tag = 'VersionedAnswers';
    v1;
    v2;
    constructor(answers) {
        this.v1 = JSON.parse(JSON.stringify(answers.v1)); // Create it owns pointer for answers.
        this.v2 = JSON.parse(JSON.stringify(answers.v2)); // Create it owns pointer for answers.
    }
    isEqual(otherAnswers) {
        return _.isEqual(this.v1, otherAnswers?.v1) && _.isEqual(this.v2, otherAnswers?.v2);
    }
}
